// import React,{useState , useEffect} from 'react'
import Layout from '../Layout/Layout'

import T1 from "../Assets/T1.jpg";
import T2 from "../Assets/T2.jpg";
import T3 from "../Assets/T3.jpg";
import T4 from "../Assets/T4.jpg";
import T5 from "../Assets/T5.jpg";
import T6 from "../Assets/T6.jpg";
import T7 from "../Assets/T7.jpg";
import T8 from "../Assets/T8.jpg";
import T9 from "../Assets/T9.jpg";

const Testimonials = () => {
    return (
        <Layout>
        <div className='Testimonials-container'>
            <h1 className='heading'>TESTIMONIALS</h1>
            <div className='T-Cards'>
                <div className='Card'>
                    <p>The movers were on time and ready to work. They were professional, always polite and friendly. Nothing was broken and they went out of their way to accommodate us in several ways. They did a fantastic job.</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T1} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Jim Donnelly</h3>
                            <h4>Santa Rosa, FL</h4>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    <p>They were great, finishing in 2.5 hours start to finish, the expected time was 4 hours. these guys were great, no gimmicks, went straight to work and were very courteous and professional. I’d have no problem recommending them.</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T2} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Noel Cruz</h3>
                            <h4>Polk County, FL</h4>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    <p>On The Go Relocation is the best moving company that my husband and I have ever used. They recently moved us from one house to another house and these guys know how to pack and move. Thank you!</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T3} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Justina Halliley</h3>
                            <h4>Boston, MA</h4>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    <p>I would use their services again in future. Jerry was excellent! He was professional, through, and friendly. Alex and Mike were efficient, hard working and professional. They made the move easy on us. Thank you!</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T4} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Kelly Poulot</h3>
                            <h4>Broward County, FL</h4>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    <p>Yuval and his helper were really great with helping my family move. Communicated professionally and gave me real expectations. Never stopped working and did it with a great attitude. Thank you so much!!</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T5} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Lucille G</h3>
                            <h4>San Francisco, CA</h4>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    <p>They did a great job moving us. Very professional and fun to work with. Fast and efficient. They took the time to wrap items to insure they were protected. Great job guys! I will highly recommend them for residential moving.</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T6} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Kenneth</h3>
                            <h4>Phoenix, AZ</h4>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    <p>We recently moved in the same suburb and were very happy with the service we received. They arrived very promptly, worked very hard and efficiently. The staff was very polite and friendly. Their price was also reasonable.</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T7} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Richard Eaton</h3>
                            <h4>Houston, TX</h4>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    <p>I could not speak more highly of On The Go who helped us move today. On time, respectful of our belongings, efficient, and friendly. A big thanks to the company and their staff for a job well done. You are awesome!</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T8} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Paul Pitman</h3>
                            <h4>New York, NY</h4>
                        </div>
                    </div>
                </div>
                <div className='Card'>
                    <p>On The Go is a professional moving company. They made our move as smooth as possible. Great value and fantastic service. The staff is extremely helping and courteous. I highly recommended them to all!</p>
                    <div className='info'>
                        <div className='Image'>
                        <img src={T9} alt='Testimonials' />
                        </div>
                        <div className='Name'>
                            <h3>Daryl Clark</h3>
                            <h4>Las Vegas, NV</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </Layout>
    )
}

export default Testimonials
